import Vue from 'vue'
import Vuex from 'vuex'
import bridge from '../utils/bridge'

Vue.use(Vuex)

const ua = navigator.userAgent
const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export default new Vuex.Store({
  state: {
    listBTItems: [],
    BTState: '',
    vin: '',
    Brand: '',
    ECM: '',
    BCM: '',
    failReason: '',
    userInfo: '',
    location: '',
    device: null,
    deviceStatus: 'unline',
    showError: 0,
    readState: 'unReading',
    clearCode: '0',
    setMileage: '',
    readingMileage: 2,
    deviceItem: null,
    connectFlag: 0,
    MVCI_LIST: [],
    userDataId: '',
    uploadStatus: '',
    source: '',
    percent_left: '',
    percent_right: '',
    ClaimTab: '0',
    isLocationGrant: '',
    VinReadFlag: 0
  },

  mutations: {
    updateList(state, list) {
      state.listBTItems = list
    },
    updateBTState(state, status) {
      state.BTState = status
    },
    updateVin(state, vin) {
      state.vin = vin
    },
    updateBrand(state, brand) {
      state.Brand = brand
    },
    updateECM(state, ecm) {
      state.ECM = ecm
    },
    updateBCM(state, bcm) {
      state.BCM = bcm
    },
    updateFailReason(state, reason) {
      state.failReason = reason
    },
    updateUserInfo(state, info) {
      state.userInfo = info
    },
    updateLocation(state, loc) {
      state.location = loc
    },
    updateDevice(state, device) {
      state.device = device
    },
    updateDeviceStatus(state, status) {
      state.deviceStatus = status
    },
    updateError(state, code) {
      state.showError = code
    },
    updataReadState(state, stateVal) {
      state.readState = stateVal
    },
    updateClearCode(state, code) {
      state.clearCode = code
    },
    updateSetMileage(state, mileage) {
      state.setMileage = mileage
    },
    updateReadingMileage(state, mileage) {
      state.readingMileage = mileage
    },
    updateDeviceItem(state, item) {
      state.deviceItem = item
    },
    updateConnectFlag(state, flag) {
      state.connectFlag = flag
    },
    UPDATE_MVCI_LIST(state, list) {
      state.MVCI_LIST = list
    },
    updateUserDataId(state, id) {
      state.userDataId = id
    },
    updateUploadStatus(state, status) {
      state.uploadStatus = status
    },
    updateSource(state, source) {
      state.source = source || 'GA'
    },
    updatePercentLeft(state, percent) {
      state.percent_left = percent
    },
    updatePercentRight(state, percent) {
      state.percent_right = percent
    },
    updateClaimTab(state, tab) {
      state.ClaimTab = tab
    },
    updateLocationAuth(state, grant) {
      state.isLocationGrant = grant
    },
    VINCompleteFlag(state, flag) {
      state.VinReadFlag = flag
    }
  },

  actions: {
    showMoreDevice({ commit, state }, devices) {
      let list = state.listBTItems.concat(devices)
      // Android 去重
      if (isAndroid) {
        const seen = {}
        list = list.reduce((acc, item) => {
          if (!seen[item.address]) {
            seen[item.address] = true
            acc.push(item)
          }
          return acc
        }, [])
      }
      console.log('====================================')
      console.log('context.state.deviceItem', state.deviceItem)
      console.log('====================================')
      const connecting = list.find(item => item.state === 'connecting')
      commit('updateDeviceItem', connecting)
      if (connecting) {
        bridge.connectDevice(connecting)
      }
      commit('updateList', list)
    }
  }
})
